<app-header></app-header>
<div class="container">
  <div class="row">
    <div class="col-12">
    <!--<div class="offset-lg-2 col-12 col-lg-9">-->
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
